import React, { Component, Fragment } from "react";
import { isMobileOnly, isTablet } from 'react-device-detect';
import { connect } from "react-redux";
import { TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Row, Col, Grid } from "@vds/grids";
import "./InternetServices.css";
import {
  redirectionHandler,
  setExistingCustomer,
  hasPendingOrder,
  setHasMutipleAddress,
  getQulaificationDetails,
} from "../containers/action";
import {
  setIsExternalAppRedirection
} from "../../../containers/actions";
import * as SiteCatalyst from "../../../sitecatalyst";
import Icon from "@vds/icons";
import { Modal, ModalTitle, ModalBody } from "@vds/modals";
import styled from "styled-components";
import { ENABLE_OMNI_CART } from "./../../../containers/constants";
import { InternetFiosService } from "./InternetFiosService";
import { InternetLTEService } from "./InternetLTEService";
import { InternetIDSService } from "./InternetIDSService";
import { Internet5GService } from "./Internet5GService";
import { Subtitle } from "@vds/typography/dist/cjs/components/Subtitle";
import { Line } from "@vds/lines";
import SpinnerComponent from '../../../Common/Spinner/Spinner';
import TextLinkCaret from "@vds/buttons/dist/cjs/components/TextLinkCaret";
import queryString from "query-string";
import {
  postUIEventLog
} from '../containers/action';
import * as SiteAnalytics from '../../../sitecatalyst';
import { VZStepper } from "../../../Common/HorizontalProgress/VZStepper";
import { withTranslation } from "react-i18next";

const LearnMoreModal = styled(Modal)`
  height: auto;
  min-height: 10rem;
  > div:first-child {
    overflow: auto;
    min-height: 10rem;
  }
  @media only screen and (max-width: 600px) {
    position: absolute;
    top: 10px;
    right: 10px;
    left: 9px;
    width: 95vw;
    height: 97vh;
    > div:first-child {
      padding: 10px;
    }
  }
`;

class InternetServices extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      enable5GLearnMoreModal: false,
      enableFiosLearnMoreModal: false,
      enableLTELearnModal: false,
      enableSpinner: false
    };
    props.postUIEventLog({ eventType: 'log', eventName: "INTERNET_SERVICES_PageLoad", sectionName: "Page" });
    const values = queryString.parse(props.location.search);
    const cid = values && values.cid;
    if (cid) {
    props.setIsExternalAppRedirection(true);
      props.getQulaificationDetails({ cid: cid });
    }
  }

  componentDidMount() {
    SiteAnalytics.trackPageInfo('Internet Services');
    if (!this.cid) {
      SiteCatalyst.trackLQAttempts(window.LQRequestBody, {
        type: "lq-address-validation",
        data: window.LQResponse,
      });
    }
  }

  otherServicesHeader = (name) => {
    return (
      <Grid className="MessageHeader" colGutter={isMobileOnly ? "true" : "false"}>
        <Row>
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
            <div className="services-header ">
              <Title size="large">
                {name
                  ? `Did you know that we also offer ${name}`
                  : "You also qualify for this service:"}
              </Title>
            </div>
          </Col>
        </Row>
        <Line type="light" noMargin />
      </Grid>
    );
  };
  modal5GChange = (enableModal) => {
    this.setState({
      enable5GLearnMoreModal: enableModal,
    });
  };

  enableSpinner = () => {
    this.setState({
      enableSpinner: true,
    });
  };

  modalFiosChange = (enableModal) => {
    this.setState({
      enableFiosLearnMoreModal: enableModal,
    });
  };

  modalLTEChange = (enableModal) => {
    this.setState({
      enableLTELearnModal: enableModal,
    });
  };

  fiosHsiRedirection = () => {
    const { addressQualificationDetails, lqQualificationDetails, isExternalAppRedirect } = this.props;
    let optixAddressResponse;
    if (ENABLE_OMNI_CART === "false") {
      optixAddressResponse = null;
    } else {
      optixAddressResponse = this.props.optixAddressQualificationDetails;
    }
    if (
      optixAddressResponse?.quoteResultsField?.priceQuotesSetField?.length > 0
    ) {
      this.props.history.push("/ExistingService");
      this.props.setExistingCustomer(true);
    } else if (isExternalAppRedirect ? lqQualificationDetails?.HasExistingService == "Y" : addressQualificationDetails?.HasExistingService) {
      isExternalAppRedirect ? this.props.history.push({ pathname: `/ExistingService`, search: this.props.history.location.search }) : this.props.history.push("/ExistingService");
      this.props.setExistingCustomer(true);
    } else if (isExternalAppRedirect ? lqQualificationDetails?.HasPendingOrder == "Y" : addressQualificationDetails?.HasPendingOrder) {
      SiteCatalyst.trackQualificationResponse(
        window.LQRequestBody,
        window.LQResponse
      );
      SiteCatalyst.trackProductsList(window.LQResponse);
      this.props.hasPendingOrder(true);
      isExternalAppRedirect ? this.props.history.push({ pathname: `/pendingOrder`, search: this.props.history.location.search }) : this.props.history.push("/pendingOrder");
      //   this.props.disableCheckAvailblity(true)
    } else if (isExternalAppRedirect ? lqQualificationDetails?.HSIStatus == "Y" : addressQualificationDetails?.RedirectToNextPage) {
      SiteCatalyst.trackQualificationResponse(
        window.LQRequestBody,
        window.LQResponse
      );
      SiteCatalyst.trackProductsList(window.LQResponse);
      SiteCatalyst.trackLQSuccess(window.LQRequestBody, {
        type: "customize-order",
        data: window.LQResponse,
      });
      if (window?.newrelic?.addPageAction) {
        window.newrelic.addPageAction("LQAttempts", {
          data: window.LQRequestBody,
        });
        window.newrelic.addPageAction("LQSuccess", {
          data: window.LQRequestBody,
        });
      }
      isExternalAppRedirect ? this.props.history.push({ pathname: `/customize-order`, search: this.props.history.location.search }) : this.props.history.push({
        pathname: "/customize-order",
        state: { prevPage: "LQ" },
      });
    }
  };

  render5GModal = () => {
    return (
      <LearnMoreModal
        ariaLabel=""
        opened={this.state.enable5GLearnMoreModal}
        disableOutsideClick={true}
        onOpenedChange={this.modal5GChange}
      >
        <ModalTitle>
          <Title size="large" primitive="h1">
            {" "}
            5G Business Internet speed and plan details{" "}
          </Title>
        </ModalTitle>
        <ModalBody>
          <Title size="medium" primitive="h2">
            {" "}
            About plan speeds{" "}
          </Title>
          <Body size="medium" primitive="h2">
            5G Business Internet is an 'up to' bandwidth service. The maximum
            bandwidth allowed will be associated with the speed tier service
            level selected for your service (e.g. 400 Mbps). Speed Tier Limit
            represents the maximum download speed but may be lower in the event
            of network congestion. Upload speeds may be lower than download
            speeds. There is no minimum bandwidth level. During the installation
            process, Verizon will assess and benchmark connection speeds and if
            necessary recommend a chage to the contracted speed tier. Customers
            may change their plan at any time (i.e. upgrade or downgrade a speed
            tier and the applicable plan). Plans will be automatically prorated
            for any month's applicable service fee.
          </Body>
          <Title size="medium" primitive="h2">
            {" "}
            10-year price guarantee{" "}
          </Title>
          <Body size="medium" primitive="h2">
            10-year price guarantee offer for new 5G Business Internet customers
            in select areas only. Guarantee applies to the internet monthly
            access fee, excluding applicable taxes, fees & equipment charges.
            Customer must also be in good standing & retain 5G Business Internet
            at the current service address. Any customer-initiated change to the
            service or service plan cancels the price gurantee (e.g., location
            changes & speed upgrades/downgrades). Changes or disruptions to 5G
            Business Internet service to your location outside of VZ's control
            will cancel the price guarantee. Terms apply. Limited time offer.
          </Body>
        </ModalBody>
      </LearnMoreModal>
    );
  };
  renderLTEModal = () => {
    return (
      <LearnMoreModal
        ariaLabel=""
        opened={this.state.enableLTELearnModal}
        disableOutsideClick={true}
        onOpenedChange={this.modalLTEChange}
      >
        <ModalTitle>
          <Title size="small" primitive="h1">
            {" "}
            Price & LTE speed details{" "}
          </Title>
        </ModalTitle>
        <ModalBody>
          <Title size="medium" primitive="h2">
            {" "}
            About data allowance & plan speeds{" "}
          </Title>
          <Body size="medium" primitive="h2">
            LTE Business Internet is available within the U.S. on Verizon's 4G
            LTE network. No domestic or international roaming. All plans wil be
            given 300 GB/mo/line of data; if usage exceeds that allowance,
            blocks of 5 GB will be automatically added to your account for an
            additional fee of $10 per block, plus taxes. After the data
            deprioritization treshold is met (varies per plan) on a line during
            any billing cycle, usage may be prioritzed behind other customers in
            the event of network congestion. Speeds represent the maximum speed
            but may be lower in the event of network congestion; upload speeds
            vary and may be lower than the download speeds. The monthly access
            fee will not be pro-rated when moving to a higher speeed tier plan
            during a billing cycle (the higher access fee will be billed); a
            line cannot move to a lower speed tier during a billing cycle.
          </Body>
          <Body size="medium" primitive="h2">
            These plans can be used for point-of-sale, mobile terminal, and
            business productivity applications. These plans cannot be used for
            certain applications, including audio/video streaming, web hosting ,
            and public/guest Wi-fi.
          </Body>
          <Title size="medium" primitive="h2">
            {" "}
            About plan pricing{" "}
          </Title>
          <Body size="medium" primitive="h2">
            Depending on speed tier purchased, pricing for LTE Business Internet
            guranteed for 12 consecutive months ($10 price increase starting
            month 13), or 24 consecutive months ($10 price increase starting
            month 25), or 36 consecutive months ($10 price increase starting
            month 37), subject to continuation of all qualifying services and
            products; price guarantee applies tobase
          </Body>
        </ModalBody>
      </LearnMoreModal>
    );
  };
  renderFiosModal = () => {
    return (
      <LearnMoreModal
        ariaLabel=""
        opened={this.state.enableFiosLearnMoreModal}
        disableOutsideClick={true}
        onOpenedChange={this.modalFiosChange}
      >
        <ModalTitle>
          <Title size="small" primitive="h1">
            {" "}
            Offer & Pricing Detail
          </Title>
        </ModalTitle>
        <ModalBody>
          <Body size="medium" primitive="h2">
            All Offers: Offers available to new business customers only, subject
            to credit review. Not available in all areas/locations. Depending on
            speed tier purchased, promotional pricing for Internet and voice
            guaranteed for 12 consecutive months ($10 increase starting month 13
            with 2 year contract), or 24 consecutive months ($10 increase
            starting month 25 with 2 year contract), or 36 consecutive months
            ($10 increase starting month 37 with 2 year contract) subject to
            continuation of qualifying products; price guarantee applies to base
            monthly rate only; excludes optional services and equipment charges;
            prices subject to increase thereafter. With no annual contract,
            price increases to then current market rate subject to applicable
            guarantee period. Select installation charges may be waived.
            Additional charges apply for inside wiring and/or other installation
            services. $49 activation fee may apply. Offers may be fulfilled via
            bill credit(s); other taxes, fees & terms apply.{" "}
            <b>Early termination fees</b> for a 2 year contract: 35% of base
            monthly charges for unexpired term. 2 year term automatically renews
            at then-current term rates unless cancelled within 30 days prior to
            or 60 days after term is renewed.<b>Money Back Guarantee (MBG)</b>{" "}
            is available with 2 year contract only and requires cancellation
            within 30 days of installation; excludes pay per view, transactional
            Video on Demand, subscriptions, per minute usage, and labor/material
            charges in excess of standard installation. Wireless router
            available for $299.99 purchase and $15/mo rental, subject to change.
            Phone equipment purchase required with VoIP, starting at $85.
            Equipment must be returned within 30 days of cancellation. Equipment
            restocking fee may apply if order is cancelled or service is
            terminated within 30 days. MBG and/or promotional offers do not
            apply to service ordered for temporary, short term or special
            events. <b>Firm Price Quote</b> is valid for 5 business days and is
            an estimate based on current pricing, promotions and taxes that are
            subject to change. Quote does not include additional charges for
            nonstandard installations. Verizon Wi-Fi available in select areas
            with qualifying packages. Software limitations and other terms
            apply. Visit business.verizon.net/wifi for details.{" "}
            <b>
              Offers are available for a limited time only and are subject to
              change without notice.
            </b>{" "}
            Wired speeds advertised. Wired & wireless speeds vary due to device
            limits, multiple users, network & other factors. See
            www.verizon.com/yourspeed for more info. Service availability
            varies.
          </Body>
        </ModalBody>
      </LearnMoreModal>
    );
  };

  handleDisplayService = () => {
    const { addressQualificationDetails, lqQualificationDetails, isExternalAppRedirect } = this.props;
    if (this.props?.redirectedFrom === "LTE") {
      const name =
        (this.props?.addressQualificationDetails?.Qualified === "true"||this.props?.addressQualificationDetails?.QualifiedCBand === "true")
          ? "5G Business Internet?"
          : this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
            "Y"
            ? "Fios Business Internet?"
            : "Internet Dedicated Service?";
      return (
        <Fragment>
          <InternetLTEService
            {...this.props}
            bgForFirst={"bgForFirst"}
            enableSpinner={this.enableSpinner}
            isMobileOnly={isMobileOnly}
            modalLTEChange={this.modalLTEChange}
          />

          {(this.props?.addressQualificationDetails?.Qualified === "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true") &&
            this.otherServicesHeader(name)}

          <Internet5GService
            {...this.props}
            bgForFirst={
              (this.props?.addressQualificationDetails?.Qualified === "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true") &&
              "bgForFirst"
            }
            enableSpinner={this.enableSpinner}
            isMobileOnly={isMobileOnly}
            modal5GChange={this.modal5GChange}
          />

          {this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
            "Y" && (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true") &&
            this.otherServicesHeader(name)}
          <InternetFiosService
            {...this.props}
            fiosHsiRedirection={this.fiosHsiRedirection}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modalFiosChange={this.modalFiosChange}
          />
          <Line type="light" noMargin />

          <InternetIDSService {...this.props} isMobileOnly={isMobileOnly} isTablet={isTablet} />
        </Fragment>
      );
    } else if (this.props?.redirectedFrom === "5G") {
      return (
        <Fragment>
          <Internet5GService
            {...this.props}
            bgForFirst={"bgForFirst"}
            enableSpinner={this.enableSpinner}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modal5GChange={this.modal5GChange}
          />

          {this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
            "Y" && (this.props?.addressQualificationDetails?.Qualified === "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true") &&
            this.otherServicesHeader("")}
          <InternetFiosService
            {...this.props}
            bgForFirst={
              (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true") &&
              "bgForFirst"
            }
            fiosHsiRedirection={this.fiosHsiRedirection}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modalFiosChange={this.modalFiosChange}
          />
          {this.props?.addressQualificationDetails?.Qualified_4g === "true" &&
            (this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
              "Y" || (this.props?.addressQualificationDetails?.Qualified === "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true")) &&
            this.otherServicesHeader("")}

          <InternetLTEService
            {...this.props}
            bgForFirst={
              this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !==
              "Y" && (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true") &&
              this.props?.addressQualificationDetails?.Qualified_4g ===
              "true" &&
              "bgForFirst"
            }
            enableSpinner={this.enableSpinner}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modalLTEChange={this.modalLTEChange}
          />
          {this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !==
            "Y" && (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true") && this.props?.addressQualificationDetails?.IDEQualified === "Y" &&
            this.otherServicesHeader("Internet Dedicated Service?")}
          <InternetIDSService {...this.props} isMobileOnly={isMobileOnly} isTablet={isTablet} />
        </Fragment>
      );
    } else if(!(this.props.isExternalAppRedirect &&
      this.props?.lqQualificationDetails?.FiOSDataStatus !== "Y" && this.props?.lqQualificationDetails?.HSIStatus !== "Y" &&
      this.props?.lqQualificationDetails?.IDEQualified !== "Y")){
      return (
        <Fragment>
          <InternetFiosService
            {...this.props}
            bgForFirst={"bgForFirst"}
            fiosHsiRedirection={this.fiosHsiRedirection}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modalFiosChange={this.modalFiosChange}
          />
          {this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
            "Y" && (this.props?.addressQualificationDetails?.Qualified == "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true") && this.otherServicesHeader("")}
          <Internet5GService
            {...this.props}
            bgForFirst={
              (this.props?.addressQualificationDetails?.Qualified == "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true") &&
              "bgForFirst"
            }
            enableSpinner={this.enableSpinner}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modal5GChange={this.modal5GChange}
          />
          {this.props?.addressQualificationDetails?.Qualified_4g === "true" &&
            (this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus ===
              "Y" || (this.props?.addressQualificationDetails?.Qualified === "true"||this.props?.addressQualificationDetails?.QualifiedCBand=== "true")) &&
            this.otherServicesHeader("")}
          <InternetLTEService
            {...this.props}
            bgForFirst={
              ((this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !==
                "Y" && (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true") &&
                this.props?.addressQualificationDetails?.Qualified_4g ===
                "true") || isExternalAppRedirect) ?
                "bgForFirst" : ""
            }
            enableSpinner={this.enableSpinner}
            isMobileOnly={isMobileOnly}
            isTablet={isTablet}
            modalLTEChange={this.modalLTEChange}
          />
          {isExternalAppRedirect ? lqQualificationDetails?.IDEQualified == "Y" : this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !==
            "Y" && (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true") && this.props?.addressQualificationDetails?.IDEQualified === "Y" &&
            this.otherServicesHeader("Internet Dedicated Service?")}

          <InternetIDSService {...this.props} isMobileOnly={isMobileOnly} isTablet={isTablet} />
        </Fragment>
      );
    }
  };

  render() {
    const fiosAem = this.props.t("fios", { ns: "fios",returnObjects:true })
    const { addressQualificationDetails, lqQualificationDetails, isExternalAppRedirect } = this.props;

    const redirectedFrom = this.props?.redirectedFrom;
    let header = "";
    let subHeader = "";
    let fiosBackground = false;

    if (
      redirectedFrom === "5G" &&
      (this.props?.addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true")
    ) {
      header = "Sorry, we can’t offer 5G Business Internet at your location.";
      subHeader =
        "We recommend these other business internet services instead.";
      fiosBackground = this.props?.addressQualificationDetails?.LQPost === "Y";
    } else if (
      redirectedFrom === "FIOS" &&
      this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !== "Y"
    ) {
      header = "Sorry, we can’t offer Fios at your location.";
      subHeader =
        "We recommend these other business internet services instead.";
    } else if (
      redirectedFrom === "LTE"
    ) {
      header = "Congrats! We offer LTE Business Internet at your location.";
      subHeader = "";
    } else {

      const lteMsg = this.props.isExternalAppRedirect ? (
        this.props?.lqQualificationDetails?.FiOSDataStatus !== "Y" && this.props?.lqQualificationDetails?.HSIStatus !== "Y" &&
        this.props?.lqQualificationDetails?.IDEQualified !== "Y") :(this.props?.addressQualificationDetails?.Qualified !== "true" &&this.props?.addressQualificationDetails?.QualifiedCBand!== "true"&&
      this.props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !== "Y" &&  this.props?.addressQualificationDetails?.LQPost?.HSIStatus !== "Y" &&
        this.props?.addressQualificationDetails?.IDEQualified !== "Y")
      header = lteMsg ?
        "Congrats! We offer LTE Business Internet at your location." : "Congrats! Multiple services are available in your area.";
      subHeader = "";
    }
    return (
      <>
        {this.state.enable5GLearnMoreModal && this.render5GModal()}
        {this.state.enableFiosLearnMoreModal && this.renderFiosModal()}
        {this.state.enableLTELearnModal && this.renderLTEModal()}
        {(this.state.enableSpinner || this.props.toggleLoadingSpinner) && <SpinnerComponent />}
        {fiosAem.showProgressBarLQ ? <VZStepper/>:<></>}
        <div className={`${isMobileOnly ? "NavHeader mobile" : 'NavHeader'}`}>
          <div className="Top-Bar">
            <TextLink
              iconPosition="left"
              className="back-link-text"
              onClick={() => this.props.history.go(-1)}
            >
              <span className="arrow-icon">
                <Icon name="caret-left" size="small" />
              </span>
              {!isMobileOnly && <span>Back</span>}
            </TextLink>
          </div>
        </div>
        <Grid
          className="OutofFranchise MessageHeader"
          style={{ marginLeft: "3px" }}
          colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
          colGutter={isMobileOnly ? "true" : "false"}
        >
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 6 }} className='pad-lt-0p'>
              <div className="services-header">
                <Title size="large" primitive="h1">{header}</Title>

                {subHeader ? <Subtitle>{subHeader}</Subtitle> : ""}
              </div>
            </Col>
          </Row>
        </Grid>
        {this.handleDisplayService()}

        {(isExternalAppRedirect ? lqQualificationDetails?.HSIStatus == "Y" : addressQualificationDetails?.LQPost?.FiOSDataStatus !==
          "Y" && addressQualificationDetails?.Qualified !== "true"&&this.props?.addressQualificationDetails?.QualifiedCBand!== "true" && addressQualificationDetails?.LQPost?.HSIStatus === "Y" && addressQualificationDetails?.DataInfo?.Plans?.length > 0) ? (
            <Grid
              className="OutofFranchise"
              style={{ marginLeft: "3px" }}
              colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
              colGutter={false}
            >
              <Line type="light" noMargin />

              <Row className={`${isMobileOnly ? "Page-Content mobile" : 'Page-Content'}`}>
                <Col
                  className="Title-section mar-lt-0p"
                  colSizes={{ mobile: 4, tablet: 9, desktop: 9 }}
                >
                  <div className="Main-Title">
                    <Body size="large" primitive="h2">
                      {" "}
                      High speed internet, with speeds up to 10/15 Mbps, is also
                      available in your area.
                    <TextLink
                        iconPosition="right"
                        onClick={() => this.fiosHsiRedirection()}
                        className="Hsi-Link"
                      >
                        <span>Shop High Speed Internet</span>
                        <span className="arrow-icon">
                          <Icon name="caret-right" size="small" />
                        </span>
                      </TextLink>
                    </Body>
                  </div>
                </Col>
              </Row>
            </Grid>
          ) : (
            <Fragment></Fragment>
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { AddressValidationPage } = state;
  console.debug("AddressValidationPage", AddressValidationPage);
  return {
    addressQualificationDetails:
      AddressValidationPage.addressQualificationDetails,
    optixAddressQualificationDetails:
      AddressValidationPage.optixAddressQualificationDetails,
    redirectedFrom: AddressValidationPage.redirectedFrom,
    toggleLoadingSpinner: AddressValidationPage.toggleLoadingSpinner,
    lqQualificationDetails: AddressValidationPage.lqQualificationDetails,
    isExternalAppRedirect: AddressValidationPage.isExternalAppRedirect
  };
};
const mapDispatchToProps = (dispatch) => ({
  redirectionHandler: (data) => {
    dispatch(redirectionHandler(data));
  },
  setExistingCustomer: (data) => {
    dispatch(setExistingCustomer(data));
  },
  hasPendingOrder: (data) => {
    dispatch(hasPendingOrder(data));
  },
  setHasMutipleAddress: (data) => {
    dispatch(setHasMutipleAddress(data));
  },
  postUIEventLog: (data) => { dispatch(postUIEventLog(data)) },
  getQulaificationDetails: (data) => { dispatch(getQulaificationDetails(data)) },
  setIsExternalAppRedirection: (params) => { dispatch(setIsExternalAppRedirection(params)) }
});
InternetServices = connect(mapStateToProps, mapDispatchToProps)(InternetServices)
export default withTranslation("fios", { withRef: true })(InternetServices);
